import * as React from 'react';
const defaultConsent = {
    consent: { necessary: false, preferences: false, statistics: false, marketing: false },
    enabled: false,
    hasConsent(needsConsent) {
        return (!this.enabled
            || needsConsent.filter((c) => !this.consent[c]).length === 0);
    },
    getDescription: () => '',
};
export const CookieConsentContext = React.createContext(defaultConsent);
const CookieConsentProvider = (props) => {
    const consent = Object.assign(Object.assign({}, defaultConsent.consent), props.consent);
    const contextValue = Object.assign(Object.assign({}, defaultConsent), { consent: consent, enabled: !!props.enabled, content: props.content, getDescription: (needsConsent) => {
            const content = props.content;
            if (!content) {
                return '';
            }
            const missingConsents = needsConsent
                .filter((c) => !consent[c])
                .map((c) => content.categories[c])
                .join(', ');
            return content.description + ' ' + missingConsents;
        } });
    return (React.createElement(CookieConsentContext.Provider, { value: contextValue }, props.children));
};
CookieConsentProvider.defaultProps = defaultConsent;
export default CookieConsentProvider;
